import { render, staticRenderFns } from "./UniMess.vue?vue&type=template&id=5d619fc8&scoped=true&"
import script from "./UniMess.vue?vue&type=script&lang=js&"
export * from "./UniMess.vue?vue&type=script&lang=js&"
import style0 from "./UniMess.vue?vue&type=style&index=0&id=5d619fc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d619fc8",
  null
  
)

export default component.exports